import { render, staticRenderFns } from "./IncomeRestaurantBaseTable.vue?vue&type=template&id=04462f53&"
import script from "./IncomeRestaurantBaseTable.vue?vue&type=script&lang=js&"
export * from "./IncomeRestaurantBaseTable.vue?vue&type=script&lang=js&"
import style0 from "./IncomeRestaurantBaseTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports